import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import React, { useEffect, useState } from "react";
import ApiEndpoints from "../network/ApiEndPoints";
import { get } from "../network/ApiController";

const RblBalance = () => {
  const [balance, setBalance] = useState({
    rbl1: 0,
    rbl2: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBalance();
  }, []);

  const fetchBalance = () => {
    setLoading(true);

    get(
      ApiEndpoints.RBL_BALANCE,
      "",
      null,
      (res) => {
        if (res?.data?.statuscode === "1000") {
          setBalance(res.data.data);
        }
        setLoading(false);
      },
      (err) => {
        console.error("Failed to fetch balance", err);
        setLoading(false);
      },
    );
  };

  return (
    <Box p={3}>
      {/* Header */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h5" fontWeight="bold">
          RBL Wallet Balances
        </Typography>

        <Button
          variant="outlined"
          size="small"
          startIcon={<RefreshIcon />}
          onClick={fetchBalance}
          disabled={loading}
        >
          Refresh
        </Button>
      </Stack>

      {loading ? (
        <Typography>Loading...</Typography>
      ) : (
        <Stack direction="row" spacing={2} flexWrap="wrap">
          {/* RBL1 Card */}
          <Card
            sx={{
              minWidth: 250,
              flex: 1,
              borderRadius: 3,
              color: "#000",
              boxShadow: 4,
            }}
          >
            <CardContent>
              <Typography variant="subtitle2" sx={{ opacity: 0.8 }}>
                RBL1 Balance
              </Typography>

              <Typography variant="h5" mt={1} fontWeight="bold">
                ₹ {Number(balance.rbl1).toLocaleString("en-IN")}
              </Typography>
            </CardContent>
          </Card>

          {/* RBL2 Card */}
          <Card
            sx={{
              minWidth: 250,
              flex: 1,
              borderRadius: 3,
              color: "#000",
              boxShadow: 4,
            }}
          >
            <CardContent>
              <Typography variant="subtitle2" sx={{ opacity: 0.8 }}>
                RBL2 Balance
              </Typography>

              <Typography variant="h5" mt={1} fontWeight="bold">
                ₹ {Number(balance.rbl2).toLocaleString("en-IN")}
              </Typography>
            </CardContent>
          </Card>
        </Stack>
      )}
    </Box>
  );
};

export default RblBalance;
